module.exports = __webpack_public_path__ + "img/logo11.dc20c5ff.png";